import React, { useRef } from "react"
import { Link } from "gatsby"
import Marquee from "react-fast-marquee"
import ButtonModalMarquee from "../components/ButtonModal/ButtonModalMarquee"

const TextMarqueeBannerPostNMCat = ({
  articleTag,
  backgroundColor,
  fontSize,
  style,
  tag,
  tagEn,
  locale,
}) => {
  const myRef = useRef(null)
  const clickElement = ref => {
    ref.current.dispatchEvent(
      new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1,
      })
    )
  }

  let content = null;

  if (articleTag) {
    const link = (
      <Link to={`/tags/${articleTag?.nodes?.[0]?.slug}`}>
        <p>{articleTag?.nodes?.[0]?.name}</p>
      </Link>
    );
    content = Array(12).fill(link);
  } else {
    const p = <p onClick={() => clickElement(myRef)}>{locale === "en" ? tagEn : tag}</p>;
    content = Array(12).fill(p); 
  }

  return (
    <>
      <Marquee
        loop={0}
        className="marquee-banner"
        gradient={false}
        style={{
          backgroundColor: backgroundColor,
          fontSize: fontSize,
          borderTop: style,
          borderBottom: style,
        }}
      >
        {content}
      </Marquee>
      <div className="hide-me">
        <ButtonModalMarquee
          myRef={myRef}
          className="button-modal"
          title="Agenda ahora"
        />
      </div>
    </>
  )
}

export default TextMarqueeBannerPostNMCat